import { useQuery, useMutation } from '@tanstack/react-query';
import { dashBoardService } from '@Services/dahboard';
import { toast } from 'react-toastify';
import getUserAccount, {
  getUserSFDetails,
  setUserSFDetails,
} from 'utils/getUserAccount';
import { authService } from '@Services/auth';
import SearchResults from '@Components/SearchResults';

const queryOptions = {
  keepPreviousData: true,
  staleTime: 10000,
};

export const useProductStatus = (equipmentNumber, enabled = false) => {
  return useQuery({
    queryKey: ['product', equipmentNumber],
    queryFn: async () => {
      const { response } = await dashBoardService.getProductStatus(
        equipmentNumber,
      );
      return response;
    },
    onError: ({ response }) => {
      // toast.error(
      //   response.data.message + `, Please enter vaild serial number`,
      //   {
      //     position: 'bottom-center',
      //     style: { width: '400px', fontSize: '13px', padding: '5px' },
      //   },
      // );/
      // console.warn('useproduct status api failed!!');
    },
    enabled,
    retry: false,
    refetchOnWindowFocus: false,
    cacheTime: 1000,
    ...queryOptions,
  });
};

export const useMultiProductStatus = (
  email,
  equipmentNumbers,
  enabled = false,
) => {
  return useQuery({
    queryKey: ['product', email, equipmentNumbers],
    queryFn: async () => {
      const { response } = await dashBoardService.getMultiProductStatus(
        email,
        equipmentNumbers,
      );
      return response;
    },
    onError: ({ response }) => {
      toast.error(
        response.data.message + `, Please enter vaild serial number`,
        {
          position: 'bottom-center',
          style: { width: '400px', fontSize: '13px', padding: '5px' },
        },
      );
    },
    enabled,
    retry: false,
    refetchOnWindowFocus: false,
    cacheTime: 1000,
    ...queryOptions,
  });
};

export const useProducts = (
  pageNumber,
  pageSize,
  searchText = '',
  pageValue,
  showDistrbutorModal = false,
) => {
  const userAccount = getUserAccount();
  return useQuery({
    // Add activePage as a dependency
    queryKey: [
      'products',
      pageNumber,
      pageSize,
      searchText,
      pageValue,
      showDistrbutorModal,
    ],
    queryFn: async () => {
      let userSFData = getUserSFDetails();
      if (!userSFData) {
        const {
          data: { response: userData },
        } = await authService.getUserDetails(userAccount.email);
        userSFData = userData;
        setUserSFDetails(userData);
      }
      const isEndUser = userSFData.userRole === 'Basic User' ? true : false;
      const payload = `${userSFData.id}/${pageNumber}/${pageSize}?isEndUser=${isEndUser}`;
      const payloadSearch = `${userSFData.id}/${pageValue}/${pageSize}?searchValue=${searchText}&isEndUser=${isEndUser}`;
      if (showDistrbutorModal) {
        return;
      } else {
        const url = searchText ? payloadSearch : payload;
        const { data } = await dashBoardService.getProducts(url);
        return data?.response;
      }
    },

    ...queryOptions,
  });
};
export const useUnregisteredProducts = (
  pageNumber,
  pageSize,
  searchTextUn = '',
  pageValue,
  distributorInstallerCheck = false,
) => {
  const userAccount = getUserAccount();
  return useQuery({
    // Add activePage as a dependency
    queryKey: [
      'unregisteredproducts',
      pageNumber,
      pageSize,
      searchTextUn,
      pageValue,
      distributorInstallerCheck,
    ],
    queryFn: async () => {
      let userSFData = getUserSFDetails();
      let companyNumber =
        userSFData.installerNumber || userSFData.distributorNumber;
      if (!userSFData) {
        const {
          data: { response: userData },
        } = await authService.getUserDetails(userAccount.email);
        userSFData = userData;
        setUserSFDetails(userData);
      }
      // const isEndUser = userSFData.userRole === 'Basic User' ? true : false;
      const payload = `${userSFData.email}/${companyNumber}/${pageNumber}/${pageSize}`;
      const payloadSearch = `${userSFData.email}/${companyNumber}/${pageValue}/${pageSize}?searchValue=${searchTextUn}`;
      if (distributorInstallerCheck) {
        return;
      } else {
        const url = searchTextUn ? payloadSearch : payload;
        const { data } = await dashBoardService.getUnregisteredProducts(url);

        return data?.response;
      }
    },

    ...queryOptions,
  });
};
export const useUnregisteredProductss = (
  pageNumber,
  pageSize,
  searchTextUn = '',
  pageValue,
  startDate,
  endDate,
) => {
  const userAccount = getUserAccount();
  return useQuery({
    // Add activePage as a dependency
    queryKey: [
      'unregisteredproductssa',
      pageNumber,
      pageSize,
      searchTextUn,
      pageValue,
      startDate,
      endDate,
    ],
    queryFn: async () => {
      let userSFData = getUserSFDetails();
      let companyNumber =
        userSFData.installerNumber || userSFData.distributorNumber;
      if (!userSFData) {
        const {
          data: { response: userData },
        } = await authService.getUserDetails(userAccount.email);
        userSFData = userData;
        setUserSFDetails(userData);
      }
      // const isEndUser = userSFData.userRole === 'Basic User' ? true : false;
      const payload = `${userSFData.email}/${startDate}/${endDate}/${pageNumber}/${pageSize}`;
      const payloadSearch = `${userSFData.email}/${startDate}/${endDate}/${pageNumber}/${pageSize}?searchValue=${searchTextUn}`;
      const url = searchTextUn ? payloadSearch : payload;
      const { data } = await dashBoardService.getMultiAllRegProducts(url);

      return data?.response;
    },

    ...queryOptions,
  });
};
export const useAllregisteredProducts = (
  pageNumber,
  pageSize,
  searchText = '',
  pageValue,
  startDate,
  endDate,
  filter = false,
) => {
  const userAccount = getUserAccount();
  return useQuery({
    // Add activePage as a dependency
    queryKey: [
      'allregisteredProducts',
      pageNumber,
      pageSize,
      searchText,
      pageValue,
      filter,
    ],
    queryFn: async () => {
      let userSFData = getUserSFDetails();
      if (!userSFData) {
        const {
          data: { response: userData },
        } = await authService.getUserDetails(userAccount.email);
        userSFData = userData;
        setUserSFDetails(userData);
      }
      const isEndUser = userSFData.userRole === 'Basic User' ? true : false;
      const payload = `${userSFData.email}/${startDate}/${endDate}/${pageNumber}/${pageSize}`;
      const payloadSearch = `${userSFData.email}/${startDate}/${endDate}/${pageNumber}/${pageSize}?searchValue=${searchText}`;
      const url = searchText ? payloadSearch : payload;
      // const url = filter ? payload : payload;
      const { data } = await dashBoardService.getMultiAllRegProducts(url);
      filter = false;
      return data?.response;
    },

    ...queryOptions,
  });
};
export const useAllUnregisteredProducts = (
  pageNumber,
  pageSize,
  searchTextUn = '',
  pageValue,
  startDate,
  endDate,
  filter = false,
) => {
  const userAccount = getUserAccount();
  return useQuery({
    // Add activePage as a dependency
    queryKey: [
      'allUnregisteredProducts',
      pageNumber,
      pageSize,
      searchTextUn,
      pageValue,
      filter,
    ],
    queryFn: async () => {
      let userSFData = getUserSFDetails();
      // let companyNumber =
      //   userSFData.installerNumber || userSFData.distributorNumber;
      // if (!userSFData) {
      //   const {
      //     data: { response: userData },
      //   } = await authService.getUserDetails(userAccount.email);
      //   userSFData = userData;
      //   setUserSFDetails(userData);
      // }
      // const isEndUser = userSFData.userRole === 'Basic User' ? true : false;
      const payload = `${userSFData.email}/${startDate}/${endDate}/${pageNumber}/${pageSize}`;
      const payloadSearch = `${userSFData.email}/${startDate}/${endDate}/${pageValue}/${pageSize}?searchValue=${searchTextUn}`;
      const url = searchTextUn ? payloadSearch : payload;
      // const url = filter ? payload : payload;
      const { data } = await dashBoardService.getMultiAllUnRegProducts(url);
      filter = false;

      return data?.response;
    },
    retry: false,
    refetchOnWindowFocus: false,
    cacheTime: 1000,
    ...queryOptions,
  });
};
export const useProduct = (email, equipmentNumber, enabled = false) => {
  return useQuery({
    queryKey: ['product', email, equipmentNumber],
    queryFn: async () => {
      let userSFData = getUserSFDetails();

      const equipment = `${userSFData.email}/${equipmentNumber}`;

      const isDistributor = `${userSFData.email}/${equipmentNumber}?distributorNumber=${userSFData.distributorNumber}`;
      const url =
        userSFData.userRole === 'Distributor' && userSFData.distributorNumber
          ? isDistributor
          : equipment;
      const { response } = await dashBoardService.getProduct(url);
      return response;
    },
    onError: ({ response }) => {
      toast.error(`Error Occured, Please go back to Dashboard!!`, {
        position: 'bottom-center',
        style: { width: '400px', fontSize: '13px', padding: '5px' },
      });
    },
    enabled,
    retry: false,
    refetchOnWindowFocus: false,
    cacheTime: 1000,
    ...queryOptions,
  });
};
export const useMultiProducts = (email, equipmentNumbers, enabled = false) => {
  return useQuery({
    queryKey: ['product', email, equipmentNumbers],
    queryFn: async () => {
      let userSFData = getUserSFDetails();

      const equipment = `${email}/${equipmentNumbers}`;

      const isDistributor = `${email}/${equipmentNumbers}?distributorNumber=${userSFData.distributorNumber}`;
      const url =
        userSFData.userRole === 'Distributor' && userSFData.distributorNumber
          ? isDistributor
          : equipment;
      const { response } = await dashBoardService.getMultiProducts(equipment);
      return response;
    },
    onError: ({ response }) => {
      // toast.error(
      //   response.data.message + `, Please enter vaild serial number`,
      //   {
      //     position: 'bottom-center',
      //     style: { width: '400px', fontSize: '13px', padding: '5px' },
      //   },
      // );
      // console.warn('use multiproduct api failed!!');
    },
    enabled,
    retry: false,
    refetchOnWindowFocus: false,
    cacheTime: 1000,
    ...queryOptions,
  });
};
export const useMultiMutationProducts = () => {
  return useMutation(
    async (multiProductPayload) => {
      let userSFData = getUserSFDetails();

      const equipment = `${userSFData.email}/${multiProductPayload}`;
      const isDistributor = `${userSFData.email}/${multiProductPayload}?distributorNumber=${userSFData.distributorNumber}`;
      const url =
        userSFData.userRole === 'Distributor' && userSFData.distributorNumber
          ? isDistributor
          : equipment;
      const res = await dashBoardService.getMultiProducts(url);
      return res.response;
    },
    {
      onError: ({ response }) => {
        toast.error(response?.data?.message, {
          position: toast.POSITION.TOP_CENTER,
          style: { width: '400px', fontSize: '13px', padding: '5px' },
        });
      },
    },
  );
};
const useMutationProduct = () => {
  return useMutation(
    async (payload) => {
      let userSFData = getUserSFDetails();
      const enteredSerialNum = [];
      const triggerEmails = [];
      payload.forEach((finalData) => {
        enteredSerialNum.push(finalData.serialNumber);
        if (finalData.triggerEmail) {
          triggerEmails.push(finalData.serialNumber);
        }
      });
      const equipment = `${userSFData.email}/${enteredSerialNum.join(
        ',',
      )}?triggerEmailsFor=${triggerEmails.join(',')}`;
      const isDistributor = `${userSFData.email}/${enteredSerialNum.join(
        ',',
      )}?distributorNumber=${userSFData.distributorNumber}`;
      const url =
        userSFData.userRole === 'Distributor' && userSFData.distributorNumber
          ? isDistributor
          : equipment;
      const res = await dashBoardService.getMultiProductStatus(url);
      return res.response;
    },
    {
      onError: ({ response }) => {
        // toast.error(
        //   response.data.message + `, Please enter vaild serial number`,
        //   {
        //     position: 'bottom-center',
        //     style: { width: '400px', fontSize: '13px', padding: '5px' },
        //   },
        // );
      },
    },
  );
};

const useMutationrequestTransfer = () => {
  return useMutation(dashBoardService.requestForTransfer, {
    onSuccess: ({ data }) => {
      toast.success(data?.message, {
        position: toast.POSITION.TOP_CENTER,
      });
    },
    onError: ({ response }) => {
      toast.error(response?.data?.message, {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
};

export const dashboardQuery = {
  useProductStatus,
  useProducts,
  useUnregisteredProducts,
  useProduct,
  useMutationProduct,
  useMutationrequestTransfer,
  useMultiProducts,
  useMultiMutationProducts,
  useAllregisteredProducts,
  useAllUnregisteredProducts,
  useUnregisteredProductss,
};
